// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ThreeDotsLoader_dotFlashing__fmM4E {
  position: relative;
  width: 10px;
  height: 10px;
  border-radius: 5px;
  background-color: #9880ff;
  color: #9880ff;
  animation: ThreeDotsLoader_dot-flashing__xaFKZ 1s infinite linear alternate;
  animation-delay: 0.5s;
  margin: 0 auto;
}
.ThreeDotsLoader_dotFlashing__fmM4E::before, .ThreeDotsLoader_dotFlashing__fmM4E::after {
  content: "";
  display: inline-block;
  position: absolute;
  top: 0;
}
.ThreeDotsLoader_dotFlashing__fmM4E::before {
  left: -15px;
  width: 10px;
  height: 10px;
  border-radius: 5px;
  background-color: #9880ff;
  color: #9880ff;
  animation: ThreeDotsLoader_dot-flashing__xaFKZ 1s infinite alternate;
  animation-delay: 0s;
}
.ThreeDotsLoader_dotFlashing__fmM4E::after {
  left: 15px;
  width: 10px;
  height: 10px;
  border-radius: 5px;
  background-color: #9880ff;
  color: #9880ff;
  animation: ThreeDotsLoader_dot-flashing__xaFKZ 1s infinite alternate;
  animation-delay: 1s;
}

@keyframes ThreeDotsLoader_dot-flashing__xaFKZ {
  0% {
    background-color: #9880ff;
  }
  50%, 100% {
    background-color: rgba(152, 128, 255, 0.2);
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/atoms/loader/ThreeDotsLoader.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,2EAAoD;EACpD,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,WAAW;EACX,qBAAqB;EACrB,kBAAkB;EAClB,MAAM;AACR;AACA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,oEAA6C;EAC7C,mBAAmB;AACrB;AACA;EACE,UAAU;EACV,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,oEAA6C;EAC7C,mBAAmB;AACrB;;AAEA;EACE;IACE,yBAAyB;EAC3B;EACA;IACE,0CAA0C;EAC5C;AACF","sourcesContent":[".dotFlashing {\r\n  position: relative;\r\n  width: 10px;\r\n  height: 10px;\r\n  border-radius: 5px;\r\n  background-color: #9880ff;\r\n  color: #9880ff;\r\n  animation: dot-flashing 1s infinite linear alternate;\r\n  animation-delay: 0.5s;\r\n  margin: 0 auto;\r\n}\r\n.dotFlashing::before, .dotFlashing::after {\r\n  content: \"\";\r\n  display: inline-block;\r\n  position: absolute;\r\n  top: 0;\r\n}\r\n.dotFlashing::before {\r\n  left: -15px;\r\n  width: 10px;\r\n  height: 10px;\r\n  border-radius: 5px;\r\n  background-color: #9880ff;\r\n  color: #9880ff;\r\n  animation: dot-flashing 1s infinite alternate;\r\n  animation-delay: 0s;\r\n}\r\n.dotFlashing::after {\r\n  left: 15px;\r\n  width: 10px;\r\n  height: 10px;\r\n  border-radius: 5px;\r\n  background-color: #9880ff;\r\n  color: #9880ff;\r\n  animation: dot-flashing 1s infinite alternate;\r\n  animation-delay: 1s;\r\n}\r\n\r\n@keyframes dot-flashing {\r\n  0% {\r\n    background-color: #9880ff;\r\n  }\r\n  50%, 100% {\r\n    background-color: rgba(152, 128, 255, 0.2);\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dotFlashing": `ThreeDotsLoader_dotFlashing__fmM4E`,
	"dot-flashing": `ThreeDotsLoader_dot-flashing__xaFKZ`
};
export default ___CSS_LOADER_EXPORT___;
